export * from './register.component';



// WEBPACK FOOTER //
// ./src/app/register/index.ts